import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft, Home, Search } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/404')({
  component: NotFoundPage,
  staticData: {
    status: 404,
  },
})

function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/30 flex items-center justify-center p-4 md:p-8">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-destructive/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-lg text-center">
        <div className="mb-8">
          <h1 className="text-[150px] md:text-[200px] font-bold text-muted/20 leading-none select-none">
            404
          </h1>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold tracking-tight mb-3">Page Not Found</h2>

        <p className="text-muted-foreground text-sm md:text-base mb-8 max-w-md mx-auto leading-relaxed">
          Oops! The page you're looking for seems to have wandered off. It might have been moved or
          doesn't exist anymore.
        </p>

        <div className="flex flex-col gap-3 sm:flex-row items-center justify-center">
          <Button asChild>
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              Go Home
            </Link>
          </Button>
          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </Button>
        </div>

        <div className="mt-12 pt-8 border-t">
          <p className="text-sm text-muted-foreground mb-4">Looking for something?</p>
          <div className="flex items-center gap-2 max-w-sm mx-auto">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <input
                type="text"
                placeholder="Search..."
                className="w-full h-10 pl-10 pr-4 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <Button variant="secondary" className="h-10">
              Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
